import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ProjectDto } from '@app/admin/models/project-dto';
import { Subject } from 'rxjs';
import { AddProjectComponent } from './add-project/add-project.component';
import { Store } from '@ngrx/store';
import { LoadProjects, FilterProjects } from '@dwo/actions';
import { getFilteredProjects, getFilter, getProjectsLoading } from '@app/core/store/selectors/project.selector';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProjectsComponent implements OnInit, OnDestroy {
  readonly displayColumns: string[] = [
    'id',
    'name',
    'externalId',
    'divisionType',
    'completionType',
    'jobFeedbackRecipientEmail',
    'weightChangeRecipientEmail',
    'actions',
  ];
  dataSource: MatTableDataSource<ProjectDto> = new MatTableDataSource();
  filter = '';
  loading = false;
  private readonly destroy$ = new Subject<void>();

  @ViewChild(MatSort, { static: false }) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private readonly store: Store,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new LoadProjects());

    this.store
      .select(getFilteredProjects)
      .pipe(takeUntil(this.destroy$))
      .subscribe((projects) => (this.dataSource.data = projects));

    this.store
      .select(getFilter)
      .pipe(takeUntil(this.destroy$))
      .subscribe((filter) => (this.filter = filter));

    this.store
      .select(getProjectsLoading)
      .pipe(takeUntil(this.destroy$))
      .subscribe((loading) => (this.loading = loading));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onRefresh(): void {
    this.store.dispatch(new LoadProjects());
  }

  onFilter(filter: string): void {
    this.store.dispatch(new FilterProjects(filter));
  }

  onAdd(): void {
    this.dialog
      .open(AddProjectComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.store.dispatch(new FilterProjects(''));
        }
      });
  }
}
